import { useFeatureFlag } from "@repo/lib/hooks/common";
import { useCallback } from "react";

const useTrackProfileUpdate = () => {
  const isWebEngageEnabled = useFeatureFlag("webEngage");
  const trackProfileUpdateEvent = useCallback(
    (profileData) => {
      if (!isWebEngageEnabled) {
        console.warn("WebEngage feature is disabled");
        return;
      }
      if (window.webengage) {
        if (profileData) {
          const { email, phoneNumber, firstName, lastName, gender } =
            profileData;
          const eventData = {
            email: email,
            ...(phoneNumber && { phone: phoneNumber }),
            firstName: firstName,
            lastName: lastName,
            ...(gender && { gender }),
          };

          window.webengage.track("profile_updated", eventData);
        } else {
          console.warn(
            "Profile data is required to track profile update event"
          );
        }
      } else {
        console.error("WebEngage is not defined");
      }
    },
    [isWebEngageEnabled]
  );

  return { trackProfileUpdateEvent };
};

export default useTrackProfileUpdate;
